/** File extensions for HEIC/HEIF images (iOS default photo format). */
export const HEIC_EXTENSIONS = new Set(['heic', 'heif']);

/** MIME types for HEIC/HEIF images. */
export const HEIC_MIME_TYPES = new Set(['image/heic', 'image/heif']);

/** Common video extensions used when mobile browsers omit MIME types. */
export const VIDEO_EXTENSIONS = new Set([
  'mp4',
  'mov',
  'webm',
  'avi',
  'wmv',
  'flv',
  'mkv',
  'm4v',
  '3gp',
]);

/** JPEG quality used when converting HEIC to a browser-displayable preview. */
export const HEIC_PREVIEW_JPEG_QUALITY = 0.85;

/** `accept` attribute value for content upload file inputs. */
export const UPLOAD_MEDIA_ACCEPT = 'image/*,video/*,.heic,.heif';

/** Human-readable list shown in upload tips. */
export const UPLOAD_MEDIA_FORMATS_LABEL = 'JPG, PNG, HEIC, MP4, MOV';
